import { render, staticRenderFns } from "./Donations.vue?vue&type=template&id=172b2fff&scoped=true"
var script = {}
import style0 from "./Donations.vue?vue&type=style&index=0&id=172b2fff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172b2fff",
  null
  
)

export default component.exports